import React, { useEffect, useState } from "react";
import ManageProvision from "../../provision/manageProvision";
import FadeIn from "react-fade-in";
import TableTopBar from "../../modal/tableTopBar";
import Table from "../../../atom/table";
import {
  DeleteIcon,
  EditPencilIcon,
  TableSortIconDownArrow,
} from "../../../utils/icons/defaultIcons";
import NewGroup from "./newGroup";
import { deleteDisplayGroup, getAllDisplayGroups } from "../../../services/api";
import { useLocation, useNavigate } from "react-router-dom";
import { Backdrop } from "@mui/material";
import Lottiefy from "../../../atom/lottie/lottie";
import * as loaderLottie from "../../../utils/lottie/loaderLottie.json";
import Notification from "../../../atom/Notification";
import Modal from "../../../atom/modal";
import ThemedButton from "../../../atom/ThemedButton/themedButton";

function DisplayGroups() {
  const path = useLocation();
  const navigate = useNavigate();
  const [manage, setManage] = useState<boolean>(false);
  const [deletebutton, setDeleteButton] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<string>("");
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [searchtext, setSearchText] = useState<any>("");
  const [handleKeyPress, setHandleKeyPress] = useState<boolean>(true);
  const [loader, setLoader] = useState<any>(false);
  const [deleteButtonLoader, setDeleteButtonLoader] = useState<boolean>(false);
  const [resultNotFound, setResultNotFound] = useState<boolean>(false);

  const [tableTitles, setTableTitles] = useState<any>([
    { key: "name", title: "Group Name", icon: <TableSortIconDownArrow /> },
    {
      key: "action_button",
      title: "",
      type: "actionIcon",
      class: "text-right -mb-2",
      icon: <EditPencilIcon />,
      action: {
        title: "edit",
        command: "edit",
        action: "click",
        tooltip: "Edit",
      },
    },
    {
      key: "action_button",
      title: "",
      type: "actionIcon",
      class: "text-right ",
      icon: <DeleteIcon />,
      action: {
        title: "delete",
        command: "delete",
        action: "click",
        tooltip: "Delete",
      },
    },
  ]);

  const [tableData, setTableData] = useState<any>([]);

  const onHandleFecth = (search?: string) => {
    setLoader(true);
    getAllDisplayGroups(search && search).then((result: any) => {
      if (!result?.success || result?.data?.data?.length === 0) {
        setLoader(false);
        setResultNotFound(true);
      } else {
        // setTableData(result?.data?.data);
        setLoader(false);
        setResultNotFound(false);
      }
      setTableData(result?.data?.data);
    });
  };

  const getDisplayGroups = () => {
    onHandleFecth();
  };
  const handleSearch = (data: string) => {
    setSearchText(data);
    onHandleFecth(data);
  };

  const handleNewGroup = () => {
    navigate(`${path?.pathname}/newgroup`, { replace: false });
  };
  const handleEdit = (action: string, data: any) => {
    navigate(`${path?.pathname}/group/${data?.uuid}`, { replace: false });
  };

  const handleDelete = () => {
    setDeleteButtonLoader(true);
    deleteDisplayGroup(deleteId).then((result: any) => {
      if (!result.success) {
        setDeleteButtonLoader(false);
        let msg = result?.message;
        Notification(
          "Failed",
          msg?.charAt(0).toUpperCase() + msg.slice(1),
          "danger"
        );
      } else {
        Notification("Success", `Deleted successfully`, "success");
        setDeleteButtonLoader(false);
        setDeleteModal(false);
        getDisplayGroups();
      }
    });
  };

  const handleDeleteModal = (action: string, data: any) => {
    setDeleteModal(true);
    setDeleteId(data?.uuid);
  };

  const actionHandler = (action: string, data: any, index: number) => {
    console.log("action", data);
    const actionsMap: any = {
      "New Group": handleNewGroup,
      edit: handleEdit,
      delete: handleDeleteModal,
    };
    const act = actionsMap[action];
    if (act) {
      act(action, data);
    } else {
      console.log("actionHandler Error");
    }
  };

  useEffect(() => {
    getDisplayGroups();
  }, []);
  return (
    <>
      <div
        data-testid="displayGroups"
        className=" h-full py-3 flex relative gap-2.5   justify-center"
      >
        {deleteModal && (
          <Modal
            title={"Delete Group"}
            closeEvent={() => {
              setDeleteModal(!deleteModal);
            }}
            icon={<DeleteIcon />}
          >
            <div>Are you sure you want to delete?</div>
            <div className="text-right absolute inset-x-0 bottom-0 mb-2 mr-2">
              <ThemedButton
                children={"Cancel"}
                theme="secondary"
                click={() => setDeleteModal(!deleteModal)}
              />
              <ThemedButton
                children={"Delete"}
                theme="primary"
                loading={deleteButtonLoader}
                click={handleDelete}
              />
            </div>
          </Modal>
        )}
        <Backdrop className="!z-[99999999999]" open={loader}>
          <Lottiefy loop={true} json={loaderLottie} height={100} width={100} />
        </Backdrop>

        <div className="h-[calc(100vh-125px)] w-[800px]  max-w-full overflow-y-auto rounded-md bg-[#FFFFFF]">
          <FadeIn>
            <div className="pt-3">
              <TableTopBar
                title={"Display Groups"}
                search={true}
                button={true}
                buttonText={"New Group"}
                actionHandler={actionHandler}
                setSearchText={setSearchText}
                handleSearch={handleSearch}
                handleKeyPress={handleKeyPress}
                setHandleKeyPress={setHandleKeyPress}
                // search_class="!w-[250px]"
                permission={"tools.display_groups.post"}
              />
            </div>

            <Table
              tableTitles={tableTitles}
              tableData={tableData}
              setTableData={setTableData}
              setTableTitles={setTableTitles}
              buttonIndex={4}
              buttonText1={"Manage"}
              manage={manage}
              setManage={setManage}
              actionHandler={actionHandler}
              buttonText2={"Delete"}
              deletebutton={deletebutton}
              resultNotFound={resultNotFound}
              setDeleteButton={setDeleteButton}
              width={"w-[800px]  max-w-full overflow-auto"}
              scrollHeight={"h-[calc(100vh-280px)] overflow-y-auto"}
            />
          </FadeIn>
        </div>
      </div>
    </>
  );
}

export default DisplayGroups;
